import * as React from "react";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import "../file/ReactFlexyTable.css";
import { callApi } from "../../utils/api";
import {
    ToastsContainer,
    ToastsContainerPosition,
    ToastsStore,
} from "react-toasts";
import moment from "moment";
import Pagination from '@material-ui/lab/Pagination';
import ExcelJS from "exceljs";
import Select from 'react-select';
import DatePicker from "antd/lib/date-picker";
import { MdOutlineFileDownload } from "react-icons/md";
import { parseCustomDate } from "../dashboard/ExcelVettingReport";
import { ADMIN_ROLE } from "../../utils/role";
import { hasPageAccess } from "../../utils/pagePermissionService";

interface AllProps {
    history: any;
}
declare var $: any;
class FinalApproveReport extends React.Component<AllProps> {
    limitList = [20, 40, 60]
    state = {
        selectVal: false,
        outreason: "",
        files: [],
        page: 1,
        limit: 20,
        totalDataCount: 0,
        rowCount: this.limitList[0],
        currentPage: 1,
        isFileRefresh: false,
        isLoading: false,
        isDownloading: false,
        isQueueDownloading: false,
        lawhandsBranches: [],
        filteredBranches: [],
        filteredBranchesproduct: [],
        banks: [],
        products: [],
        filteredProduct: [],
        fromDate: "",
        toDate: "",
        lawhands_branch: "",
        bank_name: "",
        product_id: "",
        branch: "",
        assigned_to: "",
        file_Id: "",
        branches: [],
        users: [],
    };
    async componentDidMount() {
        this.getOutTime();
        const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
        if (!hasHide) {
            this.ouTime();
        }
        this.getLawHandsBranches()
        this.getUsers();
        this.getBankBranches();
        this.getBanks();
        this.listBankproduct();

        const status: any = localStorage.getItem("dashboard_status");
        if (status == 2) {
            this.sendBalanceMin();
        }

        const currentDate = moment();
        this.setState({
            fromDate: moment(currentDate, "DD.MM.YYYY"),
            toDate: moment(currentDate, "DD.MM.YYYY"),
        }, () => {
            this.getFiles();
        })
    }

    getBankBranches() {
        callApi("GET", "bank_branch_get.php")
            .then(res => res.data)
            .then(result => {
                this.setState({ branches: result.data, filteredBranches: [] });
                if (this.state.bank_name) {
                    this.filterBranches(this.state.bank_name);
                }
            })
            .catch(err => {
                console.log(err);
            });
    }

    listBankproduct = () => {
        this.setState({ isFileRefresh: false });
        callApi("GET", "bank_product_get.php")
            .then(res => res.data)
            .then(response => {
                const files = response.data;
                this.setState({ products: files });
            })
            .catch(err => {
                console.log(err);
            });
    };

    getBanks() {
        callApi("GET", "bank_get.php")
            .then(res => res.data)
            .then(result => {
                this.setState({ banks: result.data });
            })
            .catch(err => {
                console.log(err);
            });
    }

    getUsers = () => {
        callApi("GET", "user_get.php")
            .then(res => res.data)
            .then(response => {
                this.setState({ users: response.data });
            })
            .catch(err => {
                console.log(err);
            });
    };

    getLawHandsBranches() {
        callApi("GET", "get_lawhands_branch.php")
            .then(res => res.data)
            .then(response => {
                this.setState({ lawhandsBranches: response.data });
            })
            .catch(err => {
                console.log(err);
            });
    }

    sendBalanceMin() {
        const fileid1: any = localStorage.getItem("file_Id");
        let updatedRemainingTime: any = localStorage.getItem(
            "updatedRemainingTime"
        );
        let updatedtime = Math.round(updatedRemainingTime);
        const status: any = localStorage.getItem("dashboard_status");
        let obj = {
            file_id: JSON.parse(fileid1),
            balance_min: updatedtime,
            dashboard_status: status,
        };
        callApi("POST", "process_eod_insert.php", obj)
            .then((res) => res.data)
            .then((response) => {
                localStorage.removeItem("updatedRemainingTime");
            })
            .catch((err) => {
                console.log(err);
            });
    }

    fileout = (fileid1) => {
        let fileId = JSON.parse(fileid1);
        const loginuser: any = localStorage.getItem("user1");
        let req = {
            id: fileId,
            reason: "File Out",
            created_by: JSON.parse(loginuser),
        };
        callApi("POST", "time_update.php", req)
            .then((res) => res.data)
            .then((response) => {
                localStorage.removeItem("currentfileId");
                localStorage.removeItem("query_raised_status");
                localStorage.removeItem("file_completed_status");
            });
    };

    previousPop = () => {
        $("#out_reason").modal("show");
        $("#another-reason").modal("hide");
    };
    BacktoFile = () => {
        $("#out_reason").modal("hide");
        const fileid1: any = localStorage.getItem("currentfileId");

        this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
    };
    getOutTime = () => {
        let date = new Date();
        let stratTime = date.getTime();
        localStorage.setItem("startTime", JSON.stringify(stratTime));
        let outDate = date.toLocaleDateString();
        localStorage.setItem("OutDateGet", JSON.stringify(outDate));
        var Railway = date.getMinutes();
        if (Railway < 10) {
            var TotalMinutes = "0" + Railway;
            let ouTtime = date.getHours() + ":" + TotalMinutes;
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        } else {
            let ouTtime: any = date.getHours() + ":" + date.getMinutes();
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }
    };
    ouTime = () => {
        const getfileId: any = localStorage.getItem("currentfileId");
        if (localStorage.getItem("currentfileId")) {
            $("#out_reason").modal("show");
        }
    };

    outimeGet = () => {
        this.setState({ isLoading: true });
        const fileid1: any = localStorage.getItem("currentfileId");
        const userid1: any = localStorage.getItem("user1");
        const inreason: any = localStorage.getItem("in_reason");
        const intime: any = localStorage.getItem("IntimeGet");
        const outtime: any = localStorage.getItem("outtimeGet");
        const outdate: any = localStorage.getItem("OutDateGet");
        const secondsSpent = moment(outtime, "HH:mm").diff(
            moment(intime, "HH:mm"),
            "seconds"
        );
        let updatedRemainingTime: any = localStorage.getItem(
            "updatedRemainingTime"
        );
        let updatedtime = Math.round(updatedRemainingTime);
        const status: any = localStorage.getItem("dashboard_status");
        const insertId: any = localStorage.getItem("ProcessEodInsertID");
        if (this.state.outreason == "") {
            this.setState({ selectVal: true });
        } else {
            let obj = {
                file_id: JSON.parse(fileid1),
                user_id: JSON.parse(userid1),
                in_reason: JSON.parse(inreason),
                out_reason: this.state.outreason,
                intime: JSON.parse(intime),
                outtime: JSON.parse(outtime),
                insert_date: JSON.parse(outdate),
                total_seconds: secondsSpent,
                balance_min: updatedtime,
                dashboard_status: status,
                "insert_id": insertId
            };

            callApi("POST", "process_eod_insert.php", obj)
                .then((res) => res.data)
                .then((response) => {
                    this.setState({ isLoading: false });
                    localStorage.removeItem("updatedRemainingTime");
                    localStorage.removeItem("updatedRemainingTime");
                    localStorage.removeItem("currentfileId");
                    localStorage.removeItem("in_reason");
                    localStorage.removeItem("outreason");
                    localStorage.removeItem("IntimeGet");
                    localStorage.removeItem("OutDateGet");
                    $("#out_reason").modal("hide");
                    $("#another-reason").modal("hide");
                    ToastsStore.success("Your Reason Saved Successfully");

                    let process_officerId: any =
                        localStorage.getItem("process_office_id");
                    let process_officer_id = JSON.parse(process_officerId);
                    const userid1: any = localStorage.getItem("user1");
                    let user_id = JSON.parse(userid1);
                    const take_file: any = localStorage.getItem("takenfile_id");
                    const user: any = localStorage.getItem("user");
                    const query_status: any = localStorage.getItem("query_raised_status");
                    const file_completed = localStorage.getItem("file_completed_status");
                    if (
                        process_officer_id == user_id &&
                        take_file != "" &&
                        take_file === fileid1 &&
                        query_status == "false" &&
                        file_completed == "false"
                    ) {
                        this.fileout(fileid1);
                    } else {
                        localStorage.removeItem("currentfileId");
                        localStorage.removeItem("query_raised_status");
                        localStorage.removeItem("file_completed_status");
                    }
                })
                .catch((err) => {
                    this.setState({ isLoading: false });
                    console.log(err);
                    ToastsStore.error("Your Reason Not Stored");
                });
        }
    };
    onchangeReason = (e: any) => {
        if (e.target.value == "Other") {
            this.setState({ in_reason: "", selectVal: false });
            $("#out_reason").modal("hide");
            $("#another-reason").modal("show");
        } else if (e.target.value == "select") {
            this.setState({ setResponse: false });
        } else {
            // this.setState({})
            this.setState({ [e.target.name]: e.target.value, selectVal: false });
        }
    };
    onchange = (e: any) => {
        this.setState({
            [e.target.name]: e.target.value.replace(/\s+/g, " ").trim(),
            selectVal: false,
        });
    };

    getFiles = () => {
        const { currentPage, limit, rowCount } = this.state;
        let req = {
            page: currentPage,
            limit: limit,
            from_date: this.state.fromDate,
            to_date: this.state.toDate,
            bank_private_name: this.state.bank_name,
            assigned_to: this.state.assigned_to,
            lawhands_branch: this.state.lawhands_branch,
            bank_product: this.state.product_id,
            branch: this.state.branch
        };

        this.setState({ isLoading: true });
        callApi("POST", "final_approval_report.php", req)
            .then((res) => res.data)
            .then((response) => {
                if (response.result && response.data) {
                    const { data: files } = response;
                    const pagination = response.pagination || {};
                    this.setState({
                        files,
                        totalDataCount: Number(pagination.total_records || 0),
                        currentPage: Number(pagination.current_page || 1),
                        limit: Number(pagination.per_page || limit),
                        isLoading: false,
                        isFileRefresh: true,
                    });
                } else {
                    this.setState({
                        files: [],
                        totalDataCount: 0,
                        currentPage: 1,
                        isLoading: false,
                        isFileRefresh: false,
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ isLoading: false });
            });
    };

    // Function to convert hh:mm:ss to milliseconds
    convertTimeToMilliseconds = (timeStr) => {
        const [hours, minutes, seconds] = timeStr.split(':').map(Number);
        return ((hours || 0) * 3600 + (minutes || 0) * 60 + (seconds || 0)) * 1000;
    };
// excel download function
    downloadCountExcel = () => {
        const { currentPage, limit, fromDate, toDate, bank_name, assigned_to, lawhands_branch, product_id, branch } = this.state;

        this.setState({ isDownloading: true });

        callApi("POST", "final_approval_report.php", {
            page: currentPage,
            limit,
            from_date: fromDate,
            to_date: toDate,
            bank_private_name: bank_name,
            assigned_to,
            lawhands_branch,
            bank_product: product_id,
            branch,
        })
            .then(async ({ data: { success, data } }) => {
                if (!success || !data?.length) {
                    throw new Error("No data available");
                }

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');

                // Define columns
                worksheet.columns = [
                    { header: 'S.No', key: 'serial_number', width: 10 },
                    { header: 'Name', key: 'picked_by_name', width: 25 },
                    { header: 'New Login (1st Time Query Raised)', key: 'new_login_count', width: 30 },
                    { header: 'Typing Completed Files', key: 'typing_completed_count', width: 20 },
                    { header: 'Verification Completed Files', key: 'verification_completed_count', width: 20 },
                    { header: 'Double Verification Completed Files', key: 'dverification_completed_count', width: 20 },
                    { header: 'Query Received Files', key: 'query_received_count', width: 20 },
                    { header: 'Query Working Hours', key: 'query_working_hours', width: 20 },
                    { header: 'Rectification Files', key: 'rectification_files_count', width: 15 },
                    { header: 'Final Approval Files', key: 'final_approval_files_count', width: 15 },
                    { header: 'Vetting Files', key: 'vetting_files_count', width: 15 },
                ];

                // Style headers
                worksheet.getRow(1).eachCell((cell) => {
                    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
                    cell.font = { bold: true, size: 14 };
                });

                // Add formatted data
                data.forEach((item: any) => {
                    const row = worksheet.addRow({
                        ...item,
                        new_login_count: parseInt(item.new_login_count, 10) || 0,
                        typing_completed_count: parseInt(item.typing_completed_count, 10) || 0,
                        verification_completed_count: parseInt(item.verification_completed_count, 10) || 0,
                        query_received_count: parseInt(item.query_received_count, 10) || 0,
                        query_working_hours: this.convertTimeToMilliseconds(item.query_working_hours) || null,
                        rectification_files_count: parseInt(item.rectification_files_count, 10) || 0,
                        final_approval_files_count: parseInt(item?.final_approval_files_count, 10) || 0,
                        vetting_files_count: parseInt(item.vetting_files_count, 10) || 0,
                    });

                    row.eachCell((cell: any, col: number) => {
                        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        if (col === 8) {
                            cell.value = cell.value ? cell.value / 86400000 : ''; // Convert ms to days
                            cell.numFmt = '[h]:mm:ss';
                        } else if ([1, 3, 4, 5, 6, 7, 9, 10, 11].includes(col)) {
                            cell.numFmt = '0';
                        }
                    });
                });

                // Download file
                const formattedDate = new Date().toLocaleDateString('en-GB').split('/').join('-');
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `Queue Count Report ${formattedDate}.xlsx`;
                link.click();
                window.URL.revokeObjectURL(link.href);
            })
            .catch((err) => {
                console.error(err);
                ToastsStore.error(err.message || "Network error, please try again.");
            })
            .finally(() => this.setState({ isDownloading: false }));
    };

    formatDuration = (ms: number) => {
        if (ms === 0) return "00:00:00";
        const duration = moment.duration(ms);
        return [
            Math.floor(duration.asHours()).toString().padStart(2, '0'),
            duration.minutes().toString().padStart(2, '0'),
            duration.seconds().toString().padStart(2, '0')
        ].join(':');
    };

    downloadQueueExcel = (type: string, file?: any) => {
        const { currentPage, limit, fromDate, toDate, bank_name, assigned_to, lawhands_branch, product_id, branch } = this.state;

        const requestData = {
            page: currentPage,
            limit,
            from_date: fromDate,
            to_date: toDate,
            bank_private_name: bank_name,
            pickedBy: file?.picked_by || assigned_to,
            lawhands_branch,
            bank_product: product_id,
            branch,
            download: true,
        };

        if (type === "All") {
            this.setState({ isQueueDownloading: true });
        }

        callApi("POST", "final_approval_report.php", requestData)
            .then((res) => res.data)
            .then(async ({ result, data }) => {
                if (!result || !data?.length) {
                    this.setState({ isQueueDownloading: false });
                    ToastsStore.error("No data available");
                    return;
                }

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');

                // Define columns - Bank Name and Product in separate columns for Excel
                worksheet.columns = [
                    { header: 'S.No', key: 'serial_no', width: 10 },
                    { header: 'File No', key: 'file_no', width: 20 },
                    { header: 'Existing File No', key: 'existingFileNo', width: 20 },
                    { header: 'File Type', key: 'file_type', width: 20 },
                    { header: 'Law Hands Branch Name', key: 'lh_branch', width: 20 },
                    { header: 'Bank Name', key: 'bank_name', width: 25 },
                    { header: 'Product', key: 'product_name', width: 15 },
                    { header: 'Grade', key: 'emergent_file_grade', width: 15 },
                    { header: 'Bank Branch Name', key: 'branch_name', width: 25 },
                    { header: 'Borrower Name', key: 'borrower_name', width: 25 },
                    { header: 'Property Ownername', key: 'property_owner', width: 25 },
                    { header: 'App Id', key: 'app_id', width: 25 },
                    { header: 'Login Date', key: 'login_dt', width: 22 },
                    { header: 'File Arrived Date & Time', key: 'arrived_dt', width: 26 },
                    { header: 'Final Approval Initiated by', key: 'final_approve_init_by_name', width: 22 },
                    { header: 'Final Approval Initiated Designation', key: 'final_approve_init_by_designation', width: 28 },
                    { header: 'File Emergent Initiate Date & Time', key: 'emergent_init_dt', width: 30 },
                    { header: 'Emergent Initiate Type', key: 'emergent_type', width: 20 },
                    { header: 'Emergent Initiate By', key: 'emergent_by', width: 20 },
                    { header: 'Process Officer', key: 'process_officer', width: 15 },
                    { header: 'Emergent Process officer', key: 'emergent_po', width: 20 },
                    { header: 'Verification Officer', key: 'verify_officer', width: 25 },
                    { header: 'Emergent Verification Officer', key: 'emergent_vo', width: 15 },
                    { header: 'Double Verification Officer', key: 'double_verify_officer', width: 20 },
                    { header: 'Emergent Double Verification Officer', key: 'emergent_dvo', width: 20 },
                    { header: 'File Picked By', key: 'picked_by', width: 20 },
                    { header: 'File Picked Date & Time', key: 'picked_dt', width: 26 },
                    { header: 'File Completed Date & Time', key: 'completed_dt', width: 26 },
                    { header: 'File Initial Status', key: 'initial_status', width: 15 },
                    { header: 'File Completed Status', key: 'completed_status', width: 15 },
                    { header: 'No.of Times Query Raised', key: 'no_of_time_query_raised', width: 15 },
                    { header: 'Total Count of Queries', key: 'total_query_count', width: 15 },
                    { header: 'File Waiting Time', key: 'waiting_time', width: 15 },
                    { header: 'File Working Time', key: 'working_time', width: 15 },
                    { header: 'Total LODs', key: 'no_of_lod', width: 15 },
                    { header: 'Total Related Lod', key: 'no_of_lod_related', width: 15 },
                    { header: 'Total Not Related', key: 'no_of_lod_not_related', width: 15 },
                    { header: 'Received LOD Count', key: 'lod_count', width: 15 },
                    { header: 'Received Lod Count Related', key: 'active_lod', width: 15 },
                    { header: 'Received Lod Count Not Related', key: 'inactive_lod', width: 15 },
                    { header: 'Shift Type', key: 'shift_type', width: 30 },
                    { header: 'Shift Start Time', key: 'start_time', width: 15 },
                    { header: 'Shift End Time', key: 'end_time', width: 15 },
                    { header: 'Mistakes Made by', key: 'rectify_mistake_made_by', width: 20 },
                    { header: 'Error Category', key: 'rectify_error_category', width: 20 },
                    { header: 'Rectify Category', key: 'rectify_category', width: 20 },
                    { header: 'Rectify Sub Category', key: 'rectify_sub_category', width: 20 },
                    { header: 'Rectify Reason', key: 'rectify_reason', width: 30 },
                    { header: 'What Wrong', key: 'whatWrong', width: 30 },
                    { header: 'What Change', key: 'whatChange', width: 30 },
                    { header: 'Error Location', key: 'errorLocations', width: 40 },
                    { header: 'Error Details', key: 'errorDetails', width: 40 },
                ];

                // Style header row
                worksheet.getRow(1).eachCell((cell) => {
                    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
                    cell.font = { bold: true, size: 14 };
                });

                const processedData = data.map((item: any) => {
                    // Parse dates only if they exist and are valid
                    const arrived = item.arrived_dt ? moment(item.arrived_dt, "DD-MM-YYYY HH:mm:ss") : null;
                    const picked = item.picked_dt ? moment(item.picked_dt, "DD-MM-YYYY HH:mm:ss") : null;
                    const completed = item.completed_dt ? moment(item.completed_dt, "DD-MM-YYYY HH:mm:ss") : null;

                    // Calculate differences only if both dates are valid
                    const waiting_diff = arrived && picked && arrived.isValid() && picked.isValid()
                        ? moment.duration(picked.diff(arrived)).asMilliseconds()
                        : null;

                    const working_diff = picked && completed && picked.isValid() && completed.isValid()
                        ? moment.duration(completed.diff(picked)).asMilliseconds()
                        : null;

                    // Parse times (API may return "09.30" or "09:30" format)
                    const startTimeStr = item.start_time ? String(item.start_time).replace(".", ":") : null;
                    const endTimeStr = item.end_time ? String(item.end_time).replace(".", ":") : null;
                    const start_time = startTimeStr ? moment(startTimeStr, ["HH:mm", "HH:mm:ss"]) : null;
                    const end_time = endTimeStr ? moment(endTimeStr, ["HH:mm", "HH:mm:ss"]) : null;

                    // Format errorLocations array for Excel (can contain image/doc names or location labels)
                    const errorLocationsStr = Array.isArray(item.errorLocations)
                        ? item.errorLocations
                            .map((loc: any) => (typeof loc === "object" && loc?.name ? loc.name : String(loc)))
                            .filter(Boolean)
                            .join(", ") || ""
                        : (item.errorLocations ? String(item.errorLocations) : "");

                    return {
                        ...item,
                        waiting_time: waiting_diff !== null ? waiting_diff / (24 * 60 * 60 * 1000) : null,
                        working_time: working_diff !== null ? working_diff / (24 * 60 * 60 * 1000) : null,
                        no_of_time_query_raised: parseInt(item.no_of_time_query_raised, 10) || 0,
                        total_query_count: parseInt(item.total_query_count, 10) || 0,
                        no_of_lod: item.no_of_lod || "",
                        no_of_lod_related: item.no_of_lod_related || "",
                        no_of_lod_not_related: item.no_of_lod_not_related || "",
                        lod_count: item.lod_count || "",
                        active_lod: item.active_lod || "",
                        inactive_lod: item.inactive_lod || "",
                        login_dt: item.login_dt ? parseCustomDate(item.login_dt) : "",
                        arrived_dt: item.arrived_dt ? parseCustomDate(item.arrived_dt) : "",
                        emergent_init_dt: item.emergent_init_dt ? parseCustomDate(item.emergent_init_dt) : "",
                        picked_dt: item.picked_dt ? parseCustomDate(item.picked_dt) : "",
                        completed_dt: item.completed_dt ? parseCustomDate(item.completed_dt) : "",
                        start_time: start_time && start_time.isValid()
                            ? start_time.hours() / 24 + start_time.minutes() / 1440 + start_time.seconds() / 86400
                            : item.start_time || "",
                        end_time: end_time && end_time.isValid()
                            ? end_time.hours() / 24 + end_time.minutes() / 1440 + end_time.seconds() / 86400
                            : item.end_time || "",
                        errorLocations: errorLocationsStr,
                    };
                });

                // Add data rows to Excel
                processedData.forEach((item: any) => {
                    const row = worksheet.addRow(item);

                    row.eachCell((cell: any, colNumber: number) => {
                        // Col 33: File Waiting Time, Col 34: File Working Time, Col 42: Shift Start, Col 43: Shift End
                        if ([33, 34, 42, 43].includes(colNumber)) {
                            if (cell.value !== null && cell.value !== '') {
                                cell.numFmt = '[h]:mm:ss';
                            } else {
                                cell.value = '';
                            }
                        } else if ([31, 32].includes(colNumber)) { // Query count columns
                            cell.numFmt = '0';
                        } else if ([13, 14, 17, 27, 28].includes(colNumber)) { // Date columns
                            if (cell.value) {
                                cell.numFmt = 'dd-mm-yyyy hh:mm:ss';
                            }
                        }

                        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                    });
                });

                // Generate and download file
                const currentDate = new Date();
                const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getFullYear()}`;
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = `Final Approve Report${file?.picked_by ? `-${file.picked_by}` : ''}-${formattedDate}.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);

                this.setState({ isQueueDownloading: false });
            })
            .catch((err) => {
                console.error(err);
                ToastsStore.error("Network error, please try again.");
                this.setState({ isQueueDownloading: false });
            });
    };

    handlePageChange = (event, value) => {
        this.setState({ currentPage: value }, () => {
            this.getFiles();
        });
    };

    handlePageSizeChange = (event) => {
        this.setState({ limit: event.target.value, currentPage: 1 }, () => {
            this.getFiles();
        });
    };
    goToFileDashboard = (id) => {
        const url = "/unhold-file";
        localStorage.setItem("url", url);
        let obj = { file_id: id };
        localStorage.setItem("thisPopup", JSON.stringify(obj));
        localStorage.setItem("currentfileId", JSON.stringify(id));
        this.props.history.push("/file-dashboard/" + id);
    };

    timeUpdate = (fileid, type) => {
        const loginuser: any = localStorage.getItem("user1");
        let req;
        if (type == "verification") {
            req = {
                id: fileid,
                reason: "Verification Picked",
                created_by: JSON.parse(loginuser),
                color: "#faad4c",
            };
        } else if (type == "unhold") {
            req = {
                id: fileid,
                reason: "Unhold",
                created_by: JSON.parse(loginuser),
                color: "gray",
            };
        }
        callApi("POST", "time_update.php", req)
            .then((res) => res.data)
            .then((response) => {
                if (type == "verification") {
                    window.location.href = "/work-file-verification-list/" + fileid;
                }
            });
    };

    getSelectedFile = (id) => {
        this.setState({ unholdFile: id });
    };

    handleDateChange = (date, dateStr, type) => {
        this.setState({ [type]: dateStr });
    };

    handleChange1 = (e, propName?, fieldType?) => {
        let fieldName = fieldType === 'singleselect' ? propName : e.target.name;
        let fieldValue = fieldType === 'singleselect' ? e.value : e.target.value;
        if (fieldName === "lawhands_branch") {
            const branch = fieldValue;
            const filteredUsers = this.state.users.filter(
                (itm: any) => itm.branch_id === branch
            );
            this.setState({ [fieldName]: fieldValue });
            this.setState({ filteredUsers });
        }
        if (fieldName === "assigned_to") {
            const employee_id = fieldValue;
            this.setState({ [fieldName]: fieldValue });
        }
        if (fieldName === 'bank_name') {
            const state = this.state;
            state[fieldName] = fieldValue;
            this.filterBranches(fieldValue);
            this.filterProduct(fieldValue);
        }
        if (fieldName === 'branch') {
            const state = this.state;
            state[fieldName] = fieldValue;
        }
        if (fieldName === "product_id") {
            let newProductId = e.id;
            const state = this.state;
            state.product_id = newProductId;
            this.filterBranchesproduct(fieldValue);
        }

    }
    filterProduct = (bankid: any) => {
        if (bankid) {
            const filteredProduct = this.state.products.filter(
                (branch: any) => branch.bank_id === bankid
            );
            const state = this.state;
            state.filteredProduct = filteredProduct;
            this.setState({ ...state });
        } else {
            this.setState({ product_id: "" })
        }
    };

    filterBranches = bankid => {
        const filteredBranches = this.state.branches.filter((branch: any) => branch.bank_id === bankid);
        const state = this.state;
        state.filteredBranchesproduct = filteredBranches;
        this.setState({ ...state });
    };

    filterBranchesproduct = (productid) => {
        const state = { ...this.state }; // Create a copy of the state
        const userBranches = state.lawhands_branch.split(","); // Split comma-separated branches into an array

        const filteredBranches = state.filteredBranchesproduct.filter((branch: any) => {
            // Split the branch's lawhands_branch into an array for comparison
            const branchLawhandsArray = branch.lawhands_branch.split(",");
            // Check if any of the branch's lawhands_branch matches userBranches
            const hasMatchingBranch = branchLawhandsArray.some((b) => userBranches.includes(b));

            return (
                branch.product_id === productid &&
                branch.bank_id === state.bank_name &&
                hasMatchingBranch // Check if there's a matching branch
            );
        });

        state.filteredBranches = filteredBranches;
        state.branch = "";

        this.setState(state);
    };

    disabledDate = (current) => {
        // Disable dates after today and dates before the last 3 months
        return current && (current > moment().endOf('day') || current < moment().subtract(3, 'months').startOf('day'));
    };

    render() {

        const columns = [
            {
                header: "S.No",
                key: "serial_no",
                td: (file) => (
                    <>{file.serial_no}</>
                ),
            },
            {
                header: "File No",
                key: "file_no",
                td: (file) => <>{file.file_no || "-"}</>,
            },
            {
                header: "Law Hands Branch",
                key: "lh_branch",
                td: (file) => <>{file.lh_branch || "-"}</>,
            },
            {
                header: "Bank Name and Product",
                key: "bank_product",
                td: (file) => (
                    <>
                        {[file.bank_name, file.product_name].filter(Boolean).join(" / ") || "-"}
                    </>
                ),
            },
            {
                header: "Bank Branch Name",
                key: "branch_name",
                td: (file) => <>{file.branch_name || "-"}</>,
            },
            {
                header: "Borrower Name",
                key: "borrower_name",
                td: (file) => <>{file.borrower_name || "-"}</>,
            },
            {
                header: "Property Ownername",
                key: "property_owner",
                td: (file) => <>{file.property_owner || "-"}</>,
            },
            {
                header: "APP ID",
                key: "app_id",
                td: (file) => <>{file.app_id || "-"}</>,
            },
            {
                header: "Final Approval Initiated by",
                key: "final_approve_init_by_name",
                td: (file) => (
                    <>
                        {file.final_approve_init_by_name || file.final_approve_init_by_designation || "-"}
                    </>
                ),
            },
            {
                header: "File Picked By",
                key: "picked_by",
                td: (file) => <>{file.picked_by || "-"}</>,
            },
            {
                header: "Mistakes Made by",
                key: "rectify_mistake_made_by",
                td: (file) => <>{file.rectify_mistake_made_by || "-"}</>,
            },
            {
                header: "Error Details",
                key: "errorDetails",
                td: (file) => <>{file.errorDetails || "-"}</>,
            },
        ];
        const data = this.state.files;
        const processedData = data;
        const { selectVal } = this.state;
        const { files, totalDataCount, currentPage, limit } = this.state;
        const noOfPages = Math.ceil(totalDataCount / limit);

        const lawhandsBranchesoptions = [
            // { value: "", label: "All" },
            ...this.state.lawhandsBranches
        ];
        const banksoptions = [
            { value: "", label: "All" },
            ...this.state.banks
        ];
        const usersoptions = [
            { value: "", label: "All" },
            ...this.state.users
        ];
        const filteredProduct = [
            { value: "", label: "All" },
            ...this.state.filteredProduct
        ];
        const bankbranchoptions = [
            { value: "", label: "All" },
            ...this.state.filteredBranches
        ];

        return (
            <section className="pcoded-main-container">
                <ToastsContainer
                    store={ToastsStore}
                    position={ToastsContainerPosition.TOP_RIGHT}
                />{" "}
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <div className="page-wrapper">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5 className="file-status-header">Final Approve Report</h5>
                                                    <button
                                                        className="btn btn-primary"
                                                        style={{ float: "right" }}
                                                        onClick={() => this.props.history.goBack()}
                                                    >
                                                        Back
                                                    </button>
                                                </div>
                                                <div className="card-header">
                                                    <div className="row mb-3">
                                                        <div className="col-xl-2 col-md-2 col-sm-2">
                                                            <h6>From</h6>
                                                            <DatePicker
                                                                format={'DD-MM-YYYY'}
                                                                disabledDate={this.disabledDate}
                                                                value={moment(
                                                                    this.state.fromDate,
                                                                    "DD.MM.YYYY"
                                                                )}
                                                                onChange={(date, dateStr) => this.handleDateChange(date, dateStr, 'fromDate')} />
                                                        </div>
                                                        <div className="col-xl-2 col-md-2 col-sm-2">
                                                            <h6>To</h6>
                                                            <DatePicker format={'DD-MM-YYYY'}
                                                                disabledDate={this.disabledDate}
                                                                value={moment(
                                                                    this.state.toDate,
                                                                    "DD.MM.YYYY"
                                                                )}
                                                                onChange={(date, dateStr) => this.handleDateChange(date, dateStr, 'toDate')} />
                                                        </div>
                                                        <div className="col-xl-2 col-md-2 col-sm-2">
                                                            <h6>LH Branch</h6>

                                                            {this.state.lawhandsBranches && this.state.lawhandsBranches.length > 0 && this.state.lawhandsBranches.map((opt: any) => {
                                                                opt.label = opt.name; opt.value = opt.id
                                                            }) &&
                                                                <Select options={lawhandsBranchesoptions} name="lawhands_branch"
                                                                    value={this.state.lawhandsBranches.find((o: any) => o.value === this.state.lawhands_branch)}
                                                                    onChange={(e) => this.handleChange1(e, 'lawhands_branch', 'singleselect')}
                                                                />
                                                            }
                                                        </div>
                                                        <div className="col-xl-2 col-md-2 col-sm-2">
                                                            <h6>Bank Name</h6>
                                                            {this.state.banks && this.state.banks.length > 0 && this.state.banks.map((opt: any) => {
                                                                opt.label = opt.name; opt.value = opt.id
                                                            }) &&
                                                                <Select options={banksoptions} name="bank_name"
                                                                    value={this.state.banks.find((o: any) => o.value === this.state.bank_name)}
                                                                    onChange={(e) => this.handleChange1(e, 'bank_name', 'singleselect')}
                                                                />
                                                            }
                                                        </div>
                                                        <div className="col-xl-2 col-md-2 col-sm-2">
                                                            <h6>Product</h6>
                                                            {this.state.products && this.state.products.map((opt: any) => {
                                                                opt.label = opt.product_name; opt.value = opt.id
                                                            }) &&
                                                                <Select options={filteredProduct} name="product_id"
                                                                    value={this.state.filteredProduct.find((o: any) => o.id === this.state.product_id ? this.state.product_id : "")}
                                                                    onChange={(e) => this.handleChange1(e, 'product_id', 'singleselect')}
                                                                />
                                                            }
                                                        </div>
                                                        <div className="col-xl-2 col-md-2">
                                                            <h6>Bank Branch</h6>
                                                            {this.state.filteredBranches &&
                                                                this.state.filteredBranches.length > 0 &&
                                                                this.state.filteredBranches.map((opt: any) => {
                                                                    opt.label = opt.name;
                                                                    opt.value = opt.id;
                                                                }) ? (
                                                                <Select
                                                                    options={bankbranchoptions}
                                                                    name="branch"
                                                                    value={this.state.filteredBranches.find(
                                                                        (o: any) => o.value === this.state.branch
                                                                    )}
                                                                    onChange={(e) =>
                                                                        this.handleChange1(
                                                                            e,
                                                                            "branch",
                                                                            "singleselect"
                                                                        )
                                                                    }
                                                                />
                                                            ) : <Select options={[]} name="branch" />
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-xl-2 col-md-2 col-sm-2">
                                                            <h6>Employee Name</h6>
                                                            {this.state.users && this.state.users.length > 0 && this.state.users.map((opt: any) => {
                                                                opt.label = opt.name; opt.value = opt.id
                                                            }) &&
                                                                <Select options={usersoptions} name="assigned_to"
                                                                    value={this.state.users.find((o: any) => o.value === this.state.assigned_to)}
                                                                    onChange={(e) => this.handleChange1(e, 'assigned_to', 'singleselect')}

                                                                />
                                                            }
                                                        </div>
                                                        <div className="col-xl-10 col-md-10 p-3">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary"
                                                                style={{ float: 'right' }}
                                                                onClick={() => this.getFiles()}
                                                                disabled={this.state.isLoading}
                                                            >

                                                                {this.state.isLoading ? (
                                                                    <i className="fa fa-spinner fa-spin"></i>
                                                                ) : "Search"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.state.isFileRefresh && (
                                                    <>
                                                        <div className="ml-4 mt-2 d-flex">                                                          
                                                            <button
                                                                className="download-table-xls-button excel-download-btn ml-2"
                                                                onClick={() => this.downloadQueueExcel("All")}
                                                                disabled={this.state.isQueueDownloading}
                                                            >
                                                                {this.state.isQueueDownloading ? "Downloading..." : "Download"}
                                                            </button>
                                                        </div>
                                                    </>
                                                )}
                                                <div className="card-body">
                                                    <ReactFlexyTable
                                                        data={processedData}
                                                        columns={columns}
                                                        sortable
                                                        pagination={false}
                                                        globalSearch
                                                        className="Flexy-table-unhold salary-queue-report-table"
                                                        pageSize={20}
                                                        showTotalRecords={false}
                                                    />

                                                    <div className="pagination-container">
                                                        <div>
                                                            <span>Total data count : {this.state.totalDataCount}</span>
                                                        </div>
                                                        {noOfPages > 1 && (
                                                            <Pagination
                                                                count={noOfPages}
                                                                defaultPage={this.state.page}
                                                                onChange={this.handlePageChange}
                                                                showFirstButton
                                                                showLastButton
                                                            />
                                                        )}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* THIS FOR OUT REASON MODAL */}
                <div
                    className="modal fade hide in"
                    id="out_reason"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog ">
                        <div
                            className="modal-content"
                            style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
                        >
                            <div
                                className="modal-body"
                                style={{ padding: "30px 23px 29px 24px" }}
                            >
                                <h3 style={{ margin: "auto", fontSize: "17px" }}>
                                    Please Select The Reason For To Close The File.No:
                                    {localStorage.getItem("currentfileId")}
                                </h3>
                            </div>
                            <div
                                className="form-group"
                                style={{ width: "74%", margin: "auto" }}
                            >
                                <select
                                    className="custom-select"
                                    name="outreason"
                                    value={this.state.outreason}
                                    onChange={(e) => this.onchangeReason(e)}
                                    required
                                    id="select1"
                                    style={{ marginTop: "8px" }}
                                >
                                    <option value="select">Select Your Reason</option>
                                    <option value="Query Raised">Query Raised</option>
                                    <option value=" Re-Query Raised"> Re-Query Raised</option>
                                    <option value="Hold ">Hold </option>
                                    <option value="Completed">Completed</option>
                                    <option value="Other">Others</option>
                                </select>
                                {selectVal ? (
                                    <p
                                        style={{
                                            color: "red",
                                            textAlign: "center",
                                            fontSize: "16px",
                                        }}
                                    >
                                        Please Select Your Reason{" "}
                                    </p>
                                ) : null}
                            </div>
                            <div className="modal-footer" style={{ marginTop: "27px" }}>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.isLoading}
                                    onClick={this.outimeGet}
                                    style={{ width: "76px", fontSize: "17px" }}
                                >
                                    {" "}
                                    {this.state.isLoading ? (
                                        <i className="fa fa-spinner fa-spin"></i>
                                    ) : (
                                        "OK"
                                    )}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={this.BacktoFile}
                                    style={{
                                        width: "107px",
                                        fontSize: "14px",
                                        border: "1px solid black",
                                        height: "43px",
                                    }}
                                >
                                    {" "}
                                    Back To File
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal hide fade in"
                    id="another-reason"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog ">
                        <div
                            className="modal-content"
                            style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
                        >
                            <h5 style={{ marginTop: "31px", textAlign: "center" }}>
                                Please Type a Reason To Close The File.No:{" "}
                                {localStorage.getItem("currentfileId")}{" "}
                            </h5>
                            <div
                                className="modal-body"
                                style={{ padding: "30px 23px 29px 24px" }}
                            >
                                <div
                                    className="form-group"
                                    style={{ width: "98%", margin: "auto" }}
                                >
                                    <textarea
                                        className="form-control"
                                        placeholder="Type Your Reason"
                                        name="outreason"
                                        onChange={this.onchange}
                                    />
                                    {selectVal ? (
                                        <p
                                            style={{
                                                color: "red",
                                                textAlign: "center",
                                                fontSize: "16px",
                                            }}
                                        >
                                            Please Select Your Reason{" "}
                                        </p>
                                    ) : null}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => this.outimeGet()}
                                    style={{ width: "76px", fontSize: "17px" }}
                                    disabled={this.state.isLoading}
                                >
                                    {this.state.isLoading ? (
                                        <i className="fa fa-spinner fa-spin"></i>
                                    ) : (
                                        "OK"
                                    )}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={() => this.previousPop()}
                                    style={{
                                        width: "76px",
                                        fontSize: "17px",
                                        border: "1px solid black",
                                    }}
                                >
                                    {" "}
                                    Back
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default FinalApproveReport;
